import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { Subscription, throwError } from 'rxjs';
/* import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner'; */
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { GlobalFuncService } from './global-func.service';
import { serviziRest } from 'src/environments/environment';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {

  totaleCopertiPranzo: number = 0;
  totaleCopertiCena: number = 0;
  isLoadingTotali: boolean = false;
  paginationData = { page: 1, limit: 12, totalPages: 0 };
  datUltimoAggiornamento: any = 0;
  riepilogoIncassi: any = null;
  riepilogoIncassoAnnoCorrente = { totale: 0, totaleStripeOmbrelloni: 0, totalePayPalOmbrelloni: 0, totaleBraintreeOmbrelloni: 0, totaleContantiOmbrelloni: 0, totaleStripeBar: 0, totalePayPalBar: 0, totaleBraintreeBar: 0, totaleContantiBar: 0 };
  riepilogoIncassoMeseCorrente = { totale: 0, totaleStripeOmbrelloni: 0, totalePayPalOmbrelloni: 0, totaleBraintreeOmbrelloni: 0, totaleContantiOmbrelloni: 0, totaleStripeBar: 0, totalePayPalBar: 0, totaleBraintreeBar: 0, totaleContantiBar: 0 };
  riepilogoIncassoGiornoCorrente = { totale: 0, totaleStripeOmbrelloni: 0, totalePayPalOmbrelloni: 0, totaleBraintreeOmbrelloni: 0, totaleContantiOmbrelloni: 0, totaleStripeBar: 0, totalePayPalBar: 0, totaleBraintreeBar: 0, totaleContantiBar: 0, totaleBar: 0, totaleOmbrelloni: 0 };
  loggedUser: any;
  listaUtentiRivenditori: any;
  fasciaOrariaSelezionata: any = "";
  stringaFasciaOraria: any = "Intera Giornata";
  ultimaDataLettaRiepilogoORdini: any = "";
  isFirstRiepilogoFetch: boolean = true;
  orarioRistorante: { hour: number, minute: number };
  itemsFiltrati: any; // contiene il risultato della barra di ricerca in inserimento ombrellonbe
  isUserLogged: boolean;
  serviziRest: any; // qui metter� tutte le chiamate ai servizi, così da poterli avere tutti in un unico file di properties.
  datiUtente = { "password": "", "email": "", "nome": "", "cognome": "", "telefono": "", "fotoProfilo": "" };
  tokenValue: any;
  fotoProfilo: any;
  datePicker = { dataSelezionata: { 'year': '', 'month': '', 'day': '' } };
  datePickerFinoA = { dataSelezionataFinoA: { 'day': '', 'month': '', 'year': '' } };
  datePickerEditRist = { dataEditRistorante: { 'year': '', 'month': '', 'day': '' } };

  showDeleteAllButton: boolean = false;


  isAdminLogged: boolean = false; // idRuoloUtente 1
  isGestoreBarLogged: boolean = false; // idRuoloUtente 5
  isRivenditoreServizi: boolean = false; // esercente rivenditore servizi 6
  isSuperAdmin: boolean = false; // super admin ruolo 100
  isBagninoLogged: boolean = false; // idRuoloUtente 4
  /* Fine Funzioni per idRuoloUtente */

  /* FLAG PER FILTRI DI RICERCA */

  filtraOrdiniAnnulati: boolean = false;
  filtraOrdiniContanti: boolean = false;
  filtraOrdiniOnline: boolean = false;
  filtraOrdiniMattina: boolean = false;
  filtraOrdiniPomeriggio: boolean = false;


  /* FINE FLAG PER FILTRI DI RICERCA */

  totaleUtentiRegistrati: any = 0;
  urlStreaming: any = "";
  storicoOrdiniData: any; // qui legge il servizio Rest per ottenere lo storico ordini
  jsonStoricoOrdini: any[]; // questo è il json ottenuto dal rest per lo storico ordini
  dataScelta: any; // data selezionata relativa allo storico ordini
  dataSceltaFormatoIta: any = ''; // data selezionata nel formato italiano relativa allo storico ordini, appare nella pagina html Storico Ordini
  dataSceltaFinoAFormatoIta: any = ''; // data selezionata nel formato italiano relativa allo storico ordini, appare nella pagina html Storico Ordini
  localDataOmbr: any;
  dispOmbrelloni: any;
  totaleOmbrLiberi: any = 0;
  totaleSdraioLibere: any = 0;
  totaleOmbrPrenotati: any = 0;
  totaleIncassoGiornaliero: any = 0;
  totaleOmbrelloniGiornalieri: any = 0;
  ombrelloniDuplicati: any = [];
  localDataRist: any;
  showPaginaAbbonamenti: boolean = false;

  prenotazioniRistPranzo: any;
  prenotazioniRistCena: any;
  postiDisponibiliPranzo: any;
  postiDisponibiliCena: any;

  showAlertNewBookingsBar: boolean = false;
  dataUltimoOrdineBar: number = 0;

  showAlertNewBookingsRist: boolean = false;
  dataUltimoOrdineRist: number = 0;
  datiStoricoOrdini: any;


  dataInizio = ""; // date per gestione abbonamenti
  dataInizioToShow = ""; // date per gestione abbonamenti
  dataFine = "";
  dataFineToShow = "";

  listaCani = [];
  listaServiziPrenotati = [];


  modificaInCorso: boolean = false; // se true, non faccio refresh dei dati durante esecuzione dell'app, significa che ho qualcuno che sta apportando modifiche ai dati.



  // Subscription per gestire le chiamate HTTP concorrenti
  private currentDatiRiepilogoSubscription: Subscription | null = null;


  /* Campi che mi servono per gstire i datepicker dentro la sezione ristorante*/

  dataAddRistorante: any; //qui ho dovuto usare queste due variabili per implementare il datepicker in italiano
  dataDispRistorante: any; // serve al popup per cambiare la disponibilità posti in una certa data
  dataEditRistorante: any; // ma per usarlo dovevo dichiararlo fuori e adoperare delle variabili globali 
  ristoranteEditForm: FormGroup;
  ristoranteAddForm: FormGroup;
  ristoranteDispForm: FormGroup;
  /****************************/

  listaUtenti: any; // conterrà la lista utenti
  listaUtentiData: any; // risposta della chiamata al servizio per ottenere la lista utenti
  itemsOrdiniBar: any;

  constructor(/* private spinner: Ng4LoadingSpinnerService, public ng4LoadingSpinnerService: Ng4LoadingSpinnerService */ private http: HttpClient, private router: Router, private storage: StorageService) {
    this.serviziRest = serviziRest;
    this.dataAddRistorante = "";
    this.dataEditRistorante = "";
    this.dataUltimoOrdineBar = 0;

    if (this.storage.get('token') != '' && this.storage.get('token') != null && this.storage.get('token') != undefined) {
      this.tokenValue = this.storage.get('token');
    }

    if (this.fasciaOrariaSelezionata == '' || this.fasciaOrariaSelezionata == undefined) {
      this.fasciaOrariaSelezionata = 1;
      this.onFasciaOrariaChange();
    }
  }


  private createHeaders(contentType: boolean = true): HttpHeaders {
    let headers = new HttpHeaders();
    if (contentType) {
      headers = headers.set('Accept', 'application/json');
      headers = headers.set('Content-Type', 'application/json');
    }
    headers = headers.set('Authorization', 'Bearer ' + this.tokenValue);
    return headers;
  }

  private isOraCompresa(oraInizio: number, minutoInizio: number, oraFine: number, minutoFine: number): boolean {
    const adesso = new Date();
    const minutiCorrenti = (adesso.getHours() * 60) + adesso.getMinutes();
    const minutiInizio = (oraInizio * 60) + minutoInizio;
    const minutiFine = (oraFine * 60) + minutoFine;
    return minutiCorrenti >= minutiInizio && minutiCorrenti <= minutiFine;
  }

  private isDataOdierna(dataRiferimento: any): boolean {
    if (dataRiferimento === null || dataRiferimento === undefined || dataRiferimento === '') {
      return false;
    }
    const dataNormalizzata = String(dataRiferimento).substring(0, 10);
    return dataNormalizzata === this.creaData();
  }

  getIdFasciaOrariaPerSalvataggioEValutaOrdine(idFasciaOraria: any, dataRiferimento?: any): any {
    const idFasciaOrariaNumerico = Number(idFasciaOraria);
    if (Number.isNaN(idFasciaOrariaNumerico)) {
      return idFasciaOraria;
    }

    if (!this.isDataOdierna(dataRiferimento)) {
      return idFasciaOrariaNumerico;
    }

    if (idFasciaOrariaNumerico === 2 && this.isOraCompresa(11, 0, 13, 30)) {
      return 5;
    }

    if ((idFasciaOrariaNumerico === 3 || idFasciaOrariaNumerico === 4) && this.isOraCompresa(17, 0, 19, 30)) {
      return 6;
    }

    return idFasciaOrariaNumerico;
  }

  onFasciaOrariaChange() {
    if (this.fasciaOrariaSelezionata == 1) {
      this.stringaFasciaOraria = 'Intera Giornata';
    } else if (this.fasciaOrariaSelezionata == 2) {
      this.stringaFasciaOraria = 'Mattina';
    } else if (this.fasciaOrariaSelezionata == 3) {
      this.stringaFasciaOraria = 'Pomeriggio';
    } else if (this.fasciaOrariaSelezionata == '' || this.fasciaOrariaSelezionata == null || this.fasciaOrariaSelezionata == undefined) {
      this.stringaFasciaOraria = '';
    }

    if (this.datePicker.dataSelezionata != null) {
      //  console.log("sono nel primo caso");
      this.aggiornaCalendarioOmbrelloni(this.datePicker.dataSelezionata);
    } else {
      // console.log("sono nel secondo");
      let dataOdierna = this.creaDataOdierna();
      this.aggiornaCalendarioOmbrelloni(dataOdierna);
    }
  }

  onFasciaOrariaChangeAbbonamenti() {
    if (this.fasciaOrariaSelezionata == 1) {
      this.stringaFasciaOraria = 'Intera Giornata';
    } else if (this.fasciaOrariaSelezionata == 2) {
      this.stringaFasciaOraria = 'Mattina';
    } else if (this.fasciaOrariaSelezionata == 3) {
      this.stringaFasciaOraria = 'Pomeriggio';
    } else if (this.fasciaOrariaSelezionata == '' || this.fasciaOrariaSelezionata == null || this.fasciaOrariaSelezionata == undefined) {
      this.stringaFasciaOraria = '';
    }


  }


  checkShowButtoneDeleteAll(oggi, dataScelta) {
    if (oggi == dataScelta) {
      this.showDeleteAllButton = true;
    } else {
      this.showDeleteAllButton = false;
    }
  }


  setDatiUtente() {

    /* this.ng4LoadingSpinnerService.show(); */
    const headers = this.createHeaders();

    let postData = {
      //    "email": datiUtente.email,
      //      "password" : "",
      "nome": this.datiUtente.nome,
      "cognome": this.datiUtente.cognome,
      "telefono": this.datiUtente.telefono,
      "image": this.datiUtente.fotoProfilo

    }


    this.http.post<any>(this.serviziRest.setUtente, postData, { headers })
      .subscribe(data => {
        // console.log(data);
        // console.log("tutto ok aggiornamento dati profilo");
        this.fotoProfilo = this.datiUtente.fotoProfilo;
        this.getDatiUtente(this.datiUtente.email);
        setTimeout(function () {
          /*            */
        }.bind(this), 1000);

      }, error => {
        /*          */
        // console.log(error.status);
        if (error.status == 0) {

        } else if (error.status == 400 || error.status == 401 || error.status == 403) {

        } else {

        }

        //  console.log(error);
      });


  }

  aggiornaStorico(datePicker) {  // serve ad aggiornare lo storico ordini selezionando una data dal calendario
    console.log("sono in aggiorna storico");
    /* this.ng4LoadingSpinnerService.show(); */
    if (datePicker.year != '' && datePicker.year != undefined && datePicker.year != '--') {
      /*    this.dataScelta = datePicker.year + "-" + datePicker.month + "-" + datePicker.day; */
      this.dataScelta = datePicker.year + "-" + ((datePicker.month < 10) ? ("0" + datePicker.month) : datePicker.month) + "-" + ((datePicker.day < 10) ? ("0" + datePicker.day) : datePicker.day);
      var gg = (datePicker.day * 1);
      var mm = (datePicker.month * 1);
      console.log(this.dataScelta);
      this.dataSceltaFormatoIta = ((gg < 10) ? ("0" + gg) : datePicker.day) + "-" + ((mm < 10) ? ("0" + mm) : datePicker.month) + "-" + datePicker.year;
      /*    setTimeout(function() {
           
         }.bind(this), 1000); */
      this.getDatiRiepilogo(this.dataScelta);
      this.getDisponibilitaOmbrelloniData(this.dataScelta, this.dataScelta, this.fasciaOrariaSelezionata, 'da global data dentro aggiorna storico');
    }
  }

  aggiornaDatiRiepilogo(datePicker) {  // serve ad aggiornare lo storico ordini selezionando una data dal calendario
    if (datePicker.year != '' && datePicker.year != undefined && datePicker.year != '--') {
      /*       this.dataScelta = datePicker.year + "-" + datePicker.month + "-" + datePicker.day; */
      this.dataScelta = datePicker.year + "-" + ((datePicker.month < 10) ? ("0" + datePicker.month) : datePicker.month) + "-" + ((datePicker.day < 10) ? ("0" + datePicker.day) : datePicker.day);
      var gg = (datePicker.day * 1);
      var mm = (datePicker.month * 1);
      this.dataSceltaFormatoIta = ((gg < 10) ? ("0" + gg) : datePicker.day) + "-" + ((mm < 10) ? ("0" + mm) : datePicker.month) + "-" + datePicker.year;

    } else {
      var d = new Date();
      var mese = '' + (d.getMonth() + 1);
      var giorno = '' + d.getDate();
      var anno = d.getFullYear();
      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;

      this.datePicker.dataSelezionata.year = anno + "";
      this.datePicker.dataSelezionata.day = giorno + "";
      this.datePicker.dataSelezionata.month = mese + "";
      this.dataSceltaFormatoIta = giorno + "-" + mese + "-" + anno;
      this.dataScelta = anno + "-" + mese + "-" + giorno;
    }
    if (this.ultimaDataLettaRiepilogoORdini == '' || this.ultimaDataLettaRiepilogoORdini != this.dataScelta) {
      this.isFirstRiepilogoFetch = true;
      this.datUltimoAggiornamento = 0;
    } else {
      this.isFirstRiepilogoFetch = false;
    }
    this.ultimaDataLettaRiepilogoORdini = this.dataScelta;

    this.getDataUltimoAggiornamento(this.dataScelta);
  }


  getDatiRiepilogo(dataRicevuta) {  // fa la chiamata per ottenere la disponibilità ristorante in una certa data 
    // Interrompe la chiamata precedente se è ancora in corso
    if (this.currentDatiRiepilogoSubscription) {
      this.currentDatiRiepilogoSubscription.unsubscribe();
      this.currentDatiRiepilogoSubscription = null;
    }

    // this.datiStoricoOrdini = [];
    this.listaCani = [];
    this.listaServiziPrenotati = [];
    this.totaleOmbrPrenotati = 0;
    this.totaleIncassoGiornaliero = 0;
    this.totaleOmbrelloniGiornalieri = 0;


    let dataDaModificare = null;
    dataDaModificare = dataRicevuta.split("-");
    let mese = '' + dataDaModificare[1];
    let giorno = '' + dataDaModificare[2];
    let anno = '' + dataDaModificare[0];

    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    let dataModificata = anno + "-" + mese + "-" + giorno;
    let dataModificataItaliana = giorno + "/" + mese + "/" + anno;


    if (dataRicevuta == undefined || dataRicevuta == null || dataRicevuta == '') {
      dataRicevuta = this.creaData();
    }

    this.tokenValue = this.storage.get('token');


    const headers = this.createHeaders();
    if (this.isFirstRiepilogoFetch) {
      /* this.ng4LoadingSpinnerService.show(); */
    }
    this.currentDatiRiepilogoSubscription = this.http.get<any>(this.serviziRest.getOrdiniStripe + "?data=" + dataModificata, { headers }).subscribe(data => {

      if (data != null && data['_body'] != '' && data != undefined) {
        this.isFirstRiepilogoFetch = false;
        this.datiStoricoOrdini = data;
        // console.log(this.datiStoricoOrdini);
        let dataGiornoPrenotatoTrimmato = "";
        let dataDaControllare = "";
        for (let i = 0; i < this.datiStoricoOrdini.length; i++) {

          for (let j = 0; j < this.datiStoricoOrdini[i].ombrelloni.length; j++) {
            this.totaleOmbrPrenotati++;
            if (this.datiStoricoOrdini[i].ombrelloni[j].ombrellone.labelFila.indexOf('Umani') !== -1) {
              this.datiStoricoOrdini[i].ombrelloni[j].ombrellone.posizionePrenotazione = 'Umani';
            } else {
              this.datiStoricoOrdini[i].ombrelloni[j].ombrellone.posizionePrenotazione = 'Cani';
            }
            for (let k = 0; k < this.datiStoricoOrdini[i].ombrelloni[j].listaCani.length; k++) {
              this.listaCani.push({ 'nome': this.datiStoricoOrdini[i].ombrelloni[j].listaCani[k].nome, 'taglia': this.datiStoricoOrdini[i].ombrelloni[j].listaCani[k].taglia.labelTaglia });

            }
            for (let z = 0; z < this.datiStoricoOrdini[i].ombrelloni[j].serviziPrenotatis.length; z++) {
              if (this.datiStoricoOrdini[i].ombrelloni[j].serviziPrenotatis[z].quantita != 0) {

                this.listaServiziPrenotati.push({
                  'idServizio': this.datiStoricoOrdini[i].ombrelloni[j].serviziPrenotatis[z].idServizio,
                  'quantita': this.datiStoricoOrdini[i].ombrelloni[j].serviziPrenotatis[z].quantita
                });
              }
            }



            let fasciaOraria = this.calcolaFasciaOraria(this.datiStoricoOrdini[i].ombrelloni[j].idFasciaOraria);
            var utcSecondsDataDiPrenotazione = this.datiStoricoOrdini[i].ombrelloni[j].dataPrenotazione;
            var utcSecondsGiornoPrenotato = this.datiStoricoOrdini[i].ombrelloni[j].dataInizio;
            var utcSecondsGiornoPrenotatoFine = this.datiStoricoOrdini[i].ombrelloni[j].dataFine;
            utcSecondsDataDiPrenotazione -= 7200;
            utcSecondsGiornoPrenotato -= 7200;
            utcSecondsGiornoPrenotato -= 7200;

            var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
            var dFine = new Date(0); // The 0 there is the key, which sets the date to the epoch
            var dd = new Date(0); // The 0 there is the key, which sets the date to the epoch
            dd.setUTCMilliseconds(utcSecondsDataDiPrenotazione);
            d.setUTCMilliseconds(utcSecondsGiornoPrenotato);
            dFine.setUTCMilliseconds(utcSecondsGiornoPrenotatoFine);

            let month = "" + (d.getMonth() + 1);
            let day = "" + d.getDate();

            let monthFine = "" + (dFine.getMonth() + 1);
            let dayFine = "" + dFine.getDate();

            let ora = "" + dd.getHours();
            let minuti = "" + dd.getMinutes();

            if (month.length < 2) {
              month = '0' + month;
            }
            if (day.length < 2) {
              day = '0' + day;
            }

            if (monthFine.length < 2) {
              monthFine = '0' + monthFine;
            }
            if (dayFine.length < 2) {
              dayFine = '0' + dayFine;
            }

            if (minuti.length < 2) {
              minuti = '0' + minuti;
            }

            if (day.length < 2) {
              day = '0' + day;
            }

            if (month.length < 2) {
              month = '0' + month;
            }
            if (day.length < 2) {
              day = '0' + day;
            }

            let monthD = "" + (dd.getMonth() + 1);
            let dayD = "" + dd.getDate();
            if (monthD.length < 2) {
              monthD = '0' + monthD;
            }
            if (dayD.length < 2) {
              dayD = '0' + dayD;
            }

            this.datiStoricoOrdini[i].ombrelloni[j].dataGiornoInserimentoPrenotazione = dayD + "/" + monthD + "/" + dd.getFullYear() + " " + ora + ":" + minuti;
            this.datiStoricoOrdini[i].ombrelloni[j].dataGiornoInserimentoPrenotazioneTrimmata = dayD + "/" + monthD + "/" + dd.getFullYear();
            this.datiStoricoOrdini[i].ombrelloni[j].dataPrenotazioneInizio = day + "/" + month + "/" + d.getFullYear();
            this.datiStoricoOrdini[i].ombrelloni[j].dataPrenotazioneFine = dayFine + "/" + monthFine + "/" + dFine.getFullYear();
            this.datiStoricoOrdini[i].ombrelloni[j].dataDaControllare = d.getFullYear() + "-" + month + "-" + day;
            this.datiStoricoOrdini[i].ombrelloni[j].dataModificata = dataModificata;
            this.datiStoricoOrdini[i].ombrelloni[j].dataModificataItaliana = dataModificataItaliana;
            this.datiStoricoOrdini[i].ombrelloni[j].fasciaOraria = fasciaOraria;
            this.datiStoricoOrdini[i].ombrelloni[j].listaCani = this.listaCani;
            this.datiStoricoOrdini[i].ombrelloni[j].listaServiziPrenotati = this.listaServiziPrenotati;
            //  console.log( this.datiStoricoOrdini[i].ombrelloni[j].listaCani);
            this.listaCani = [];
            this.listaServiziPrenotati = [];
            // console.log(this.datiStoricoOrdini[i].ombrelloni[j].dataPrenotazioneStripe);
            /*   if (dataModificata == this.datiStoricoOrdini[i].ombrelloni[j].dataDaControllare) {
                this.totaleIncassoGiornaliero += this.datiStoricoOrdini[i].ombrelloni[j].costo;
                this.totaleOmbrelloniGiornalieri++;
              } */

          }
        }

        //    console.log(this.datiStoricoOrdini);
      } else {
        this.datiStoricoOrdini = [];
      }

      /*        */

      // Pulizia della subscription una volta completata
      this.currentDatiRiepilogoSubscription = null;
    }, error => {
      if (error.status == 0) {
        /*          */
      } else {

      }

      // Pulizia della subscription anche in caso di errore
      this.currentDatiRiepilogoSubscription = null;
    });

  }



  getDataUltimoAggiornamento(dataRicevuta) {
    // Bypassa completamente la chiamata a getDataAggiornamentoOrdiniGiornalieri
    // e chiama direttamente getDatiRiepilogo per risparmiare chiamate
    this.getDatiRiepilogo(dataRicevuta);

    /*
    let dataDaModificare = null;
    dataDaModificare = dataRicevuta.split("-");
    let mese = '' + dataDaModificare[1];
    let giorno = '' + dataDaModificare[2];
    let anno = '' + dataDaModificare[0];

    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    let dataModificata = anno + "-" + mese + "-" + giorno;


    if (dataRicevuta == undefined || dataRicevuta == null || dataRicevuta == '') {
      dataRicevuta = this.creaData();
    }
    this.tokenValue = this.storage.get('token');


    const headers = this.createHeaders();
    if (this.isFirstRiepilogoFetch) {
      //       this.spinner.show();
    }
    this.http.get<any>(this.serviziRest.getDataAggiornamentoOrdiniGiornalieri + "?data=" + dataModificata, { headers }).subscribe(data => {
      // console.log(data['_body']);
      // console.log(this.datUltimoAggiornamento);
      // Sempre aggiorna i dati, rimuovendo il controllo condizionale
      this.getDatiRiepilogo(dataRicevuta);
      this.datUltimoAggiornamento = data['_body'];
      //       this.spinner.hide();
    });
    */
  }



  calcolaFasciaOraria(fasciaOraria) {
    if (fasciaOraria == 1) {
      return "Intera Giornata";
    } else if (fasciaOraria = 2) {
      return "Mattina";
    } else if (fasciaOraria = 3) {
      return "Pomeriggio";
    } else {
      return "Fascia Oraria non specificata";
    }
  }


  getOmbrDuplicati() {



    this.tokenValue = this.storage.get('token');

    const headers = this.createHeaders();

    /*     this.spinner.show(); */

    this.http.get<any>(this.serviziRest.getOmbrDuplicati, { headers }).subscribe(data => {
      this.ombrelloniDuplicati = data;

      // console.log(this.ombrelloniDuplicati);
      for (let i = 0; i < this.ombrelloniDuplicati.length; i++) {

        var utcSecondsDataDiPrenotazioneUno = this.ombrelloniDuplicati[i].prenotazione1.dataPrenotazione;
        var utcSecondsGiornoPrenotatoUno = this.ombrelloniDuplicati[i].prenotazione1.dataInizio;
        var utcSecondsDataDiPrenotazioneDue = this.ombrelloniDuplicati[i].prenotazione2.dataPrenotazione;
        var utcSecondsGiornoPrenotatoDue = this.ombrelloniDuplicati[i].prenotazione2.dataInizio;

        utcSecondsDataDiPrenotazioneUno -= 7200;
        utcSecondsGiornoPrenotatoUno -= 7200;
        utcSecondsDataDiPrenotazioneDue -= 7200;
        utcSecondsGiornoPrenotatoDue -= 7200;


        var d = new Date(0);
        var dd = new Date(0);

        var d_Due = new Date(0);
        var dd_Due = new Date(0);

        dd.setUTCMilliseconds(utcSecondsDataDiPrenotazioneUno);
        d.setUTCMilliseconds(utcSecondsGiornoPrenotatoUno);

        dd_Due.setUTCMilliseconds(utcSecondsDataDiPrenotazioneDue);
        d_Due.setUTCMilliseconds(utcSecondsGiornoPrenotatoDue);

        let month = "" + (d.getMonth() + 1);
        let day = "" + d.getDate();
        let ora = "" + dd.getHours();
        let minuti = "" + dd.getMinutes();

        let month_Due = "" + (d_Due.getMonth() + 1);
        let day_Due = "" + d_Due.getDate();
        let ora_Due = "" + dd_Due.getHours();
        let minuti_Due = "" + dd_Due.getMinutes();

        // Prenotazione 1

        if (month.length < 2) {
          month = '0' + month;
        }
        if (day.length < 2) {
          day = '0' + day;
        }

        if (minuti.length < 2) {
          minuti = '0' + minuti;
        }

        if (ora.length < 2) {
          ora = '0' + ora;
        }

        // Prenotazione 2

        if (month_Due.length < 2) {
          month_Due = '0' + month_Due;
        }
        if (day_Due.length < 2) {
          day_Due = '0' + day_Due;
        }

        if (minuti_Due.length < 2) {
          minuti_Due = '0' + minuti_Due;
        }

        if (ora_Due.length < 2) {
          ora_Due = '0' + ora_Due;
        }

        let monthD = "" + (dd.getMonth() + 1);
        let dayD = "" + dd.getDate();

        let monthD_Due = "" + (dd_Due.getMonth() + 1);
        let dayD_Due = "" + dd_Due.getDate();



        if (monthD.length < 2) {
          monthD = '0' + monthD;
        }
        if (dayD.length < 2) {
          dayD = '0' + dayD;
        }

        if (monthD_Due.length < 2) {
          monthD_Due = '0' + monthD_Due;
        }
        if (dayD_Due.length < 2) {
          dayD_Due = '0' + dayD_Due;
        }

        this.ombrelloniDuplicati[i].prenotazione1.dataGiornoPrenotato = dayD + "/" + monthD + "/" + dd.getFullYear() + "  " + ora + ":" + minuti;
        this.ombrelloniDuplicati[i].prenotazione1.dataPrenotazioneStripe = day + "/" + month + "/" + d.getFullYear();
        this.ombrelloniDuplicati[i].prenotazione2.dataGiornoPrenotato = dayD_Due + "/" + monthD_Due + "/" + dd_Due.getFullYear() + "  " + ora_Due + ":" + minuti_Due;
        this.ombrelloniDuplicati[i].prenotazione2.dataPrenotazioneStripe = day_Due + "/" + month_Due + "/" + d_Due.getFullYear();

      }



      setTimeout(function () {
        //this.getSdraioDisponibili(dataRicevuta);
        this.spinner.hide();
      }.bind(this), 1500);

    }, error => {
      setTimeout(function () {
        //this.getSdraioDisponibili(dataRicevuta);
        this.spinner.hide();
      }.bind(this), 1500);
      if (error.status == 0) {
      } else {
      }

    });

  }


  getUrlStreaming() {

    this.tokenValue = this.storage.get('token');

    const headers = this.createHeaders(false);

    this.http.get<any>(this.serviziRest.getUrlStreaming, { headers }).subscribe(data => {

      this.urlStreaming = data['_body'];
      // console.log(this.urlStreaming);
    }, error => {
      if (error.status == 0) {

      } else {

      }

    });

  }

  creaDataOdierna() {
    var d = new Date();
    var mese = '' + (d.getMonth() + 1);
    var giorno = '' + d.getDate();
    var anno = d.getFullYear();
    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;

    return giorno + "-" + mese + "-" + anno;
  }

  aggiornaCalendarioOmbrelloni(dataSelezionata) {  // serve ad aggiornare lo storico ordini selezionando una data dal calendario
    // console.log("sono dentro aggiornaCalendarioOmbrelloni");
    // console.log(this.datePicker);
    if (dataSelezionata != null) {
      if (dataSelezionata.year != '' && dataSelezionata.year != undefined && dataSelezionata.year != '--') {
        this.dataScelta = dataSelezionata.year + "-" + dataSelezionata.month + "-" + dataSelezionata.day;

        var gg = (dataSelezionata.day * 1);
        var mm = (dataSelezionata.month * 1);
        this.dataSceltaFormatoIta = ((gg < 10) ? ("0" + gg) : dataSelezionata.day) + "-" + ((mm < 10) ? ("0" + mm) : dataSelezionata.month) + "-" + dataSelezionata.year;
        this.dataScelta = dataSelezionata.year + "-" + ((dataSelezionata.month < 10) ? ("0" + dataSelezionata.month) : dataSelezionata.month) + "-" + ((dataSelezionata.day < 10) ? ("0" + dataSelezionata.day) : dataSelezionata.day);
      }
    } else {
      var d = new Date();
      var mese = '' + (d.getMonth() + 1);
      var giorno = '' + d.getDate();
      var anno = d.getFullYear();
      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;

      this.datePicker.dataSelezionata.year = anno + "";
      this.datePicker.dataSelezionata.day = giorno + "";
      this.datePicker.dataSelezionata.month = mese + "";
      this.dataSceltaFormatoIta = giorno + "-" + mese + "-" + anno;
      this.dataScelta = anno + "-" + mese + "-" + giorno;
    }
    /* this.ng4LoadingSpinnerService.show(); */
    // console.log("sto aggiornado il calendario ombrelloni con i seguenti dati: " + 'dataInizio ' + this.dataInizio + 'dataFine ' + this.dataFine + 'fasciaOraria' + this.fasciaOrariaSelezionata);

    this.getDisponibilitaOmbrelloniData(this.dataScelta, this.dataScelta, this.fasciaOrariaSelezionata, 'da globaldata dentro aggiorna calendario');

    //console.log(this.dataScelta);

  }



  aggiornaCalendarioRistorante(datePicker) {  // serve ad aggiornare lo storico ordini selezionando una data dal calendario
    if (datePicker.year != '' && datePicker.year != undefined && datePicker.year != '--') {
      this.dataScelta = datePicker.year + "-" + datePicker.month + "-" + datePicker.day;
      var gg = (datePicker.day * 1);
      var mm = (datePicker.month * 1);
      this.dataSceltaFormatoIta = ((gg < 10) ? ("0" + gg) : datePicker.day) + "-" + ((mm < 10) ? ("0" + mm) : datePicker.month) + "-" + datePicker.year;
      this.dataScelta = datePicker.year + "-" + ((datePicker.month < 10) ? ("0" + datePicker.month) : datePicker.month) + "-" + ((datePicker.day < 10) ? ("0" + datePicker.day) : datePicker.day);
    } else {
      var d = new Date();
      var mese = '' + (d.getMonth() + 1);
      var giorno = '' + d.getDate();
      var anno = d.getFullYear();
      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;

      this.datePicker.dataSelezionata.year = anno + "";
      this.datePicker.dataSelezionata.day = giorno + "";
      this.datePicker.dataSelezionata.month = mese + "";
      this.dataSceltaFormatoIta = giorno + "-" + mese + "-" + anno;
      this.dataScelta = anno + "-" + mese + "-" + giorno;
    }
    /* this.ng4LoadingSpinnerService.show(); */
    this.getPrenotazioniRistorante(this.dataScelta);

    //  console.log(this.dataScelta);

  }

  getIsAdmin() {
    if (this.isUserLogged == true) {

      this.tokenValue = this.storage.get('token');

      const headers = this.createHeaders();

      this.http.get<any>(this.serviziRest.isAdmin, { headers }).subscribe(data => {

        this.isAdminLogged = data;
      }, error => {
        if (error['status'] === 401) {
          alert("E' necessario effettuare il login");
          this.logout();
        }
      });
    }
  }


  getRuoloUtente() {
    if (this.isUserLogged == true) {
      this.tokenValue = this.storage.get('token');

      const headers = this.createHeaders();

      this.http.get<any>(this.serviziRest.getRuoloUtente, { headers }).subscribe(data => {
        this.isGestoreBarLogged = data == 5 ? true : false;
        this.isRivenditoreServizi = data == 6 ? true : false;
        this.isBagninoLogged = data == 4 ? true : false;
        this.isSuperAdmin = data == 100 ? true : false;


        //  console.log(this.isGestoreBarLogged);
      }), error => {
        // console.log("oppure qui dentro dà errore");
      };
    }
  }



  getDatiUtente(userData) {



    // console.log(this.tokenValue);
    const headers = this.createHeaders();

    let postData = {
      "email": userData.email

    }

    this.http.post<any>(this.serviziRest.getUtente, postData, { headers })
      .subscribe(data => {
        let tempUserdata = data;
        console.log(data);
        this.datiUtente.nome = tempUserdata.nome;
        this.datiUtente.cognome = tempUserdata.cognome;
        this.datiUtente.telefono = tempUserdata.telefono;
        this.datiUtente.email = tempUserdata.email;
        this.datiUtente.fotoProfilo = tempUserdata.image;
        if (tempUserdata.image != null && tempUserdata.image != undefined && tempUserdata.image != '') {
          this.fotoProfilo = tempUserdata.image;
        } else {
          this.fotoProfilo = '';
        }

        // console.log(this.globalData.datiUtente.fotoProfilo);

      }, error => {
        // console.log(error.status);

        // console.log(error);
      });


  }

  getDisponibilitaOmbrelloniData(dataInizio: string, dataFine: string, idFasciaOraria: number, _provenienzaPage?: string): void {
    // Validazione e normalizzazione dei parametri
    const dataInizioNormalized = this.normalizeDate(dataInizio, this.dataInizio);
    const dataFineNormalized = this.normalizeDate(dataFine, this.dataFine || dataInizioNormalized);

    // Aggiorna this.dataFine se necessario
    if (!this.dataFine) {
      this.dataFine = dataInizioNormalized;
    }

    // Formattazione delle date
    const dataModificataInizio = this.formatData(dataInizioNormalized);
    const dataModificataFine = this.formatData(dataFineNormalized);

    // Validazione e normalizzazione fascia oraria
    const fasciaOrariaValida = idFasciaOraria || 1;
    if (!idFasciaOraria) {
      this.fasciaOrariaSelezionata = 1;
      this.onFasciaOrariaChange();
    }

    // Preparazione headers
    this.tokenValue = this.storage.get('token');
    const headers = this.createHeaders(false);

    // Verifica se mostrare il pulsante delete all
    this.checkShowButtoneDeleteAll(this.creaData(), dataModificataInizio);

    // Unsubscribe dalla subscription precedente per evitare memory leak
    if (this.localDataOmbr) {
      this.localDataOmbr.unsubscribe();
    }

    // Chiamata HTTP
    this.localDataOmbr = this.http.get<any>(
      `${this.serviziRest.getOmbrelloni}${dataModificataInizio}&dataFine=${dataModificataFine}&idFasciaOraria=${fasciaOrariaValida}`,
      { headers }
    ).subscribe({
      next: (data) => {
        this.dispOmbrelloni = data;
        this.totaleOmbrLiberi = data?.filter((ombr: any) => ombr.disponibile == '1').length || 0;
      },
      error: (error) => {
        console.error('Errore nel caricamento disponibilità ombrelloni:', error);
        this.dispOmbrelloni = [];
        this.totaleOmbrLiberi = 0;
      }
    });
  }

  private normalizeDate(date: string, fallback: string): string {
    // Ritorna la data se valida, altrimenti il fallback, altrimenti la data corrente
    if (date && date !== '' && date !== 'undefined') {
      return date;
    }
    if (fallback && fallback !== '' && fallback !== 'undefined') {
      return fallback;
    }
    return this.creaData();
  }

  getSdraioDisponibili(dataRicevuta) {  // fa la chiamata per ottenere la disponibilità ombrelloni in una certa data 
    // console.log("ciao");
    let dataDaModificare = null;
    dataDaModificare = dataRicevuta.split("-");
    let mese = '' + dataDaModificare[1];
    let giorno = '' + dataDaModificare[2];
    let anno = '' + dataDaModificare[0];

    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    let dataModificata = anno + "-" + mese + "-" + giorno;


    /* this.ng4LoadingSpinnerService.show(); */
    if (dataRicevuta == undefined || dataRicevuta == null || dataRicevuta == '') {
      dataRicevuta = this.creaData();
    } else {

      this.tokenValue = this.storage.get('token');
      // console.log("Siamo dentro home, getDispOmbrelloni: " + val);
      const headers = this.createHeaders(false);

      //console.log(this.serviziRest.getPrenotazioniRistorante);

      this.http.get<any>(this.serviziRest.getNumeroSdraioDisponibili + "&data=" + dataModificata, { headers }).subscribe(data => {
        this.totaleSdraioLibere = data;
        // console.log(this.totaleSdraioLibere);
      }, error => {
      });

    }
  }







  getPrenotazioniRistorante(dataRicevuta) {  // fa la chiamata per ottenere la disponibilità ristorante in una certa data 
    let dataDaModificare = null;
    dataDaModificare = dataRicevuta.split("-");
    let mese = '' + dataDaModificare[1];
    let giorno = '' + dataDaModificare[2];
    let anno = '' + dataDaModificare[0];

    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    let dataModificata = anno + "-" + mese + "-" + giorno;


    /* this.ng4LoadingSpinnerService.show(); */
    if (dataRicevuta == undefined || dataRicevuta == null || dataRicevuta == '') {
      dataRicevuta = this.creaData();
    } else {

      this.tokenValue = this.storage.get('token');
      // console.log("Siamo dentro getPrenotazioniRistorante con data: " + dataRicevuta);
      const headers = this.createHeaders(false);

      //console.log(this.serviziRest.getPrenotazioniRistorante);
      this.localDataRist = null;
      this.localDataRist = this.http.get<any>(this.serviziRest.getPrenotazioniRistorante + dataModificata + "&idTurno=1", { headers }).subscribe(data => {
        this.prenotazioniRistPranzo = null;
        this.totaleCopertiPranzo = 0;
        this.prenotazioniRistPranzo = data;
        for (let i = 0; i < this.prenotazioniRistPranzo.length; i++) {
          this.totaleCopertiPranzo += this.prenotazioniRistPranzo[i].numeroCoperti;
        }

        if (this.prenotazioniRistPranzo != null && this.prenotazioniRistPranzo.length != 0) {

          if (this.dataUltimoOrdineRist == 0) {
            this.dataUltimoOrdineRist = this.prenotazioniRistPranzo[this.prenotazioniRistPranzo.length - 1].dataPrenotazione;
            this.showAlertNewBookingsRist = true;
            //   console.log(this.dataUltimoOrdineRist);
          }

          if (this.dataUltimoOrdineRist < this.prenotazioniRistPranzo[this.prenotazioniRistPranzo.length - 1].dataPrenotazione) {
            this.dataUltimoOrdineRist = this.prenotazioniRistPranzo[this.prenotazioniRistPranzo.length - 1].dataPrenotazione;
            this.showAlertNewBookingsRist = true;
            window.scrollTo(0, 0);
            this.playAlarm();
          }


          //   console.log(this.prenotazioniRistPranzo);
        }

        setTimeout(function () {
          //   
        }.bind(this), 1000);

      }, error => {
        //
        //    console.log(error.status);


        //   console.log(error);
      });

      this.http.get<any>(this.serviziRest.getPrenotazioniRistorante + dataRicevuta + "&idTurno=2", { headers }).subscribe(data => {
        this.prenotazioniRistCena = null;
        this.prenotazioniRistCena = data;
        this.totaleCopertiCena = 0;
        for (let i = 0; i < this.prenotazioniRistCena.length; i++) {
          this.totaleCopertiCena += this.prenotazioniRistCena[i].numeroCoperti;
        }
        if (this.prenotazioniRistCena != null && this.prenotazioniRistCena.length != 0) {

          if (this.dataUltimoOrdineRist == 0) {
            this.dataUltimoOrdineRist = this.prenotazioniRistCena[this.prenotazioniRistCena.length - 1].dataPrenotazione;
            this.showAlertNewBookingsRist = true;
            //   console.log(this.dataUltimoOrdineRist);
          }

          if (this.dataUltimoOrdineRist < this.prenotazioniRistCena[this.prenotazioniRistCena.length - 1].dataPrenotazione) {
            this.dataUltimoOrdineRist = this.prenotazioniRistCena[this.prenotazioniRistCena.length - 1].dataPrenotazione;
            this.showAlertNewBookingsRist = true;
            window.scrollTo(0, 0);
            this.playAlarm();
          }


          //    console.log(this.prenotazioniRistCena);
        }


        //    console.log(this.prenotazioniRistCena);
        setTimeout(function () {
          /*            */
        }.bind(this), 1000);

      }, error => {
        /*          */
        //   console.log(error.status);


        // console.log(error);
      });

    }


    this.getDisponibilitaPranzo(dataModificata);
    this.getDisponibilitaCena(dataModificata);




  }



  getDisponibilitaPranzo(data) {
    let dataModificata = null;

    if (data == '' || data == null || data == undefined) {
      var d = new Date();
      var mese = '' + this.dataScelta.month;
      var giorno = '' + this.dataScelta.day;
      var anno = this.dataScelta.year
      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;
      dataModificata = anno + "-" + mese + "-" + giorno;
    } else {

      let dataDaModificare = null;
      dataDaModificare = data.split("-");
      let mese = '' + dataDaModificare[1];
      let giorno = '' + dataDaModificare[2];
      let anno = '' + dataDaModificare[0];

      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;
      dataModificata = anno + "-" + mese + "-" + giorno;
    }


    const headers = this.createHeaders();

    let postData = {
      "data": dataModificata,
      "idTurno": '1',
      "postiDisponibili": '0'
    }



    this.http.post<any>(this.serviziRest.getDisponibilitaMassima, postData, { headers })
      .subscribe(data => {

        this.postiDisponibiliPranzo = data;
      }, error => {

        //   console.log(error.status);
        //   console.log(error);
      });


  }

  getDisponibilitaCena(data) {
    let dataModificata = null;

    if (data == '' || data == null || data == undefined) {
      var d = new Date();
      var mese = '' + this.dataScelta.month;
      var giorno = '' + this.dataScelta.day;
      var anno = this.dataScelta.year
      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;
      dataModificata = anno + "-" + mese + "-" + giorno;
    } else {

      let dataDaModificare = null;
      dataDaModificare = data.split("-");
      let mese = '' + dataDaModificare[1];
      let giorno = '' + dataDaModificare[2];
      let anno = '' + dataDaModificare[0];

      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;
      dataModificata = anno + "-" + mese + "-" + giorno;
    }


    const headers = this.createHeaders();

    let postData = {
      "data": dataModificata,
      "idTurno": '2',
      "postiDisponibili": '0'
    }

    this.http.post<any>(this.serviziRest.getDisponibilitaMassima, postData, { headers })
      .subscribe(data => {
        this.postiDisponibiliCena = data;

      }, error => {

        //    console.log(error.status);
        //    console.log(error);
      });

  }


  getListaUtentiByRuolo(idRuolo) {
    const headers = this.createHeaders();
    this.http.get<any>(this.serviziRest.getUtentiByIdRuolo + idRuolo, { headers }).subscribe(data => {

      if (idRuolo == '6') {
        this.listaUtentiRivenditori = data;
      }
      setTimeout(function () {
        /*          */
        /*         console.log(this.listaUtenti); */
      }.bind(this), 1000);

    })
  }

  getListaUtenti() { // serve ad ottenere la lista degli utenti registrati
    /* this.ng4LoadingSpinnerService.show(); */

    const headers = this.createHeaders(false);

    this.listaUtentiData = this.http.get<any>(this.serviziRest.getListaUtenti, { headers }).subscribe(data => {

      this.listaUtenti = data;
      this.totaleUtentiRegistrati = this.listaUtenti.length;
      setTimeout(function () {

        /*         console.log(this.listaUtenti); */
      }.bind(this), 1000);

    })
  }
  creaDataUTC() {
    var d = new Date();
    var g = d.getUTCDate();
    var m = d.getUTCMonth() + 1;
    var data = d.getUTCFullYear() + "-";
    if (m < 10) {
      data = data + "0";
    }
    data = data + m + "-";
    if (g < 10) {
      data = data + "0";
    }
    data = data + g + "";
    return data;
  }

  getOrdiniBar() {
    /* this.ng4LoadingSpinnerService.show(); */
    var dataScelta = this.creaData();
    this.tokenValue = this.storage.get('token');

    //console.log("Siamo dentro gestione magazzino con token: " + this.tokenValue);

    const headers = this.createHeaders(false);

    this.http.get<any>(this.serviziRest.getOrdiniBarGiorno + dataScelta, { headers }).subscribe(data => {
      let itemsOrdiniBarTemp = null;
      itemsOrdiniBarTemp = data;
      this.itemsOrdiniBar = itemsOrdiniBarTemp;
      //   console.log(this.itemsOrdiniBar);

      if (this.itemsOrdiniBar != null && this.itemsOrdiniBar.length != 0) {

        if (this.dataUltimoOrdineBar == 0) {
          this.dataUltimoOrdineBar = this.itemsOrdiniBar[this.itemsOrdiniBar.length - 1].dataOrdine;
          this.showAlertNewBookingsBar = true;
          //console.log(this.dataUltimoOrdineBar);
        }

        if (this.dataUltimoOrdineBar < this.itemsOrdiniBar[this.itemsOrdiniBar.length - 1].dataOrdine) {
          this.dataUltimoOrdineBar = this.itemsOrdiniBar[this.itemsOrdiniBar.length - 1].dataOrdine;
          this.showAlertNewBookingsBar = true;
          window.scrollTo(0, 0);
          this.playAlarm();
        }
      }
      for (let i = 0; i < this.itemsOrdiniBar.length; i++) {
        var utcSeconds = this.itemsOrdiniBar[i].dataOrdine;
        utcSeconds += 0; // attualmente la timezone corrisponde a Roma. Tutto ok.
        var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
        d.setUTCMilliseconds(utcSeconds);
        this.itemsOrdiniBar[i].prezzoTotaleOrdini = 0;

        let ora = "" + d.getHours();
        let minuti = "" + d.getMinutes();


        let monthD = "" + (d.getMonth() + 1);
        let dayD = "" + d.getDate();

        if (ora.length < 2) {
          ora = '0' + ora;
        }
        if (minuti.length < 2) {
          minuti = '0' + minuti;
        }

        if (monthD.length < 2) {
          monthD = '0' + monthD;
        }
        if (dayD.length < 2) {
          dayD = '0' + dayD;
        }

        this.itemsOrdiniBar[i].dataOrdineStringa = dayD + "/" + monthD + "/" + d.getFullYear() + " " + ora + ":" + minuti;
        for (let j = 0; j < this.itemsOrdiniBar[i].elementiOrdineBar.length; j++) {
          this.itemsOrdiniBar[i].elementiOrdineBar[j].prezzoTotale = this.itemsOrdiniBar[i].elementiOrdineBar[j].prezzo * this.itemsOrdiniBar[i].elementiOrdineBar[j].quantita
          this.itemsOrdiniBar[i].prezzoTotaleOrdini += (this.itemsOrdiniBar[i].elementiOrdineBar[j].prezzoTotale) * 1;
        }
      }
      setTimeout(function () {

        //   console.log(this.listaUtenti);
      }.bind(this), 2000);



      //    console.log(this.itemsOrdiniBar);

    }, error => {

      //   console.log(error.status);


      //   console.log(error);
    });

  }



  creaData() {
    var d = new Date();
    var mese = '' + (d.getMonth() + 1);
    var giorno = '' + d.getDate();
    var anno = d.getFullYear();
    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;
    return anno + "-" + mese + "-" + giorno;
  }

  creaDataDatePicker() {
    var d = new Date();
    var mese = '' + (d.getMonth() + 1);
    var giorno = '' + d.getDate();
    var anno = d.getFullYear();
    if (mese.length < 2) mese = '0' + mese;
    if (giorno.length < 2) giorno = '0' + giorno;

    this.datePicker.dataSelezionata.year = anno + "";
    this.datePicker.dataSelezionata.day = giorno + "";
    this.datePicker.dataSelezionata.month = mese + "";
    this.dataScelta = anno + "-" + mese + "-" + giorno;
  }

  playAlarm() {
    let audio = new Audio();
    audio.src = "./assets/newBooking.mp3";
    audio.load();
    audio.play();
  }
  logout() {
    this.isUserLogged = false;
    this.loggedUser = null;
    this.tokenValue = '';
    this.storage.set('token', '');
    this.storage.set('username', '');
    this.router.navigateByUrl("/", { skipLocationChange: false });

  }



  aggiornaDatiRiepilogoIncassi(datePicker) {
    if (datePicker.year != '' && datePicker.year != undefined && datePicker.year != '--') {
      this.dataScelta = datePicker.year + "-" + datePicker.month + "-" + datePicker.day;
      var gg = (datePicker.day * 1);
      var mm = (datePicker.month * 1);
      this.dataSceltaFormatoIta = ((gg < 10) ? ("0" + gg) : datePicker.day) + "-" + ((mm < 10) ? ("0" + mm) : datePicker.month) + "-" + datePicker.year;

    } else {
      var d = new Date();
      var mese = '' + (d.getMonth() + 1);
      var giorno = '' + d.getDate();
      var anno = d.getFullYear();
      if (mese.length < 2) mese = '0' + mese;
      if (giorno.length < 2) giorno = '0' + giorno;

      this.datePicker.dataSelezionata.year = anno + "";
      this.datePicker.dataSelezionata.day = giorno + "";
      this.datePicker.dataSelezionata.month = mese + "";
      this.dataSceltaFormatoIta = giorno + "-" + mese + "-" + anno;
      this.dataScelta = anno + "-" + mese + "-" + giorno;
    }

    this.getRiepilogoIncassi();

  }


  getRiepilogoIncassi() {  // fa la chiamata per ottenere la disponibilità ristorante in una certa data 
    const headers = this.createHeaders();

    this.http.get<any>(this.serviziRest.getRiepilogoIncassi, { headers }).subscribe(data => {
      this.riepilogoIncassi = data;
      this.filtraIncassi();
    });
  }


  filtraIncassi() {

    this.resettaIncassi();

    for (let i = 0; i < this.riepilogoIncassi.length; i++) {
      if (this.riepilogoIncassi[i].mese != null) {
        this.riepilogoIncassi[i].mese = this.riepilogoIncassi[i].mese.length < 2 ? 0 + this.riepilogoIncassi[i].mese : this.riepilogoIncassi[i].mese;
      }
      if (this.riepilogoIncassi[i].giorno != null) {
        let dateObject = new Date(this.riepilogoIncassi[i].giorno);
        this.riepilogoIncassi[i].giorno = dateObject.toLocaleString("it-IT", { day: "numeric" }).length < 2 ? 0 + dateObject.toLocaleString("it-IT", { day: "numeric" }) : dateObject.toLocaleString("it-IT", { day: "numeric" });
      }

      // calcola incassi dell'anno

      if (this.riepilogoIncassi[i].mese == null && this.riepilogoIncassi[i].giorno == null) {
        this.riepilogoIncassoAnnoCorrente.totale += parseInt(this.riepilogoIncassi[i].stripe, 10) + parseInt(this.riepilogoIncassi[i].paypal, 10) + parseInt(this.riepilogoIncassi[i].braintree, 10) + parseInt(this.riepilogoIncassi[i].allaCassa, 10);

        this.riepilogoIncassoAnnoCorrente.totaleStripeOmbrelloni += parseInt(this.riepilogoIncassi[i].stripe, 10);
        this.riepilogoIncassoAnnoCorrente.totalePayPalOmbrelloni += parseInt(this.riepilogoIncassi[i].paypal, 10);
        this.riepilogoIncassoAnnoCorrente.totaleBraintreeOmbrelloni += parseInt(this.riepilogoIncassi[i].braintree, 10);
        this.riepilogoIncassoAnnoCorrente.totaleContantiOmbrelloni += parseInt(this.riepilogoIncassi[i].allaCassa, 10);

      }
      // calcola incassi del mese
      if (this.riepilogoIncassi[i].mese != null && this.riepilogoIncassi[i].giorno == null && this.riepilogoIncassi[i].mese == this.datePicker.dataSelezionata.month) {
        this.riepilogoIncassoMeseCorrente.totale += parseInt(this.riepilogoIncassi[i].stripe, 10) + parseInt(this.riepilogoIncassi[i].paypal, 10) + parseInt(this.riepilogoIncassi[i].braintree, 10) + parseInt(this.riepilogoIncassi[i].allaCassa, 10);

        this.riepilogoIncassoMeseCorrente.totaleStripeOmbrelloni += parseInt(this.riepilogoIncassi[i].stripe, 10);
        this.riepilogoIncassoMeseCorrente.totalePayPalOmbrelloni += parseInt(this.riepilogoIncassi[i].paypal, 10);
        this.riepilogoIncassoMeseCorrente.totaleBraintreeOmbrelloni += parseInt(this.riepilogoIncassi[i].braintree, 10);
        this.riepilogoIncassoMeseCorrente.totaleContantiOmbrelloni += parseInt(this.riepilogoIncassi[i].allaCassa, 10);

      }

      // calcola incassi del giorno
      if (this.riepilogoIncassi[i].mese == this.datePicker.dataSelezionata.month && this.riepilogoIncassi[i].giorno == this.datePicker.dataSelezionata.day) {
        this.riepilogoIncassoGiornoCorrente.totale = parseInt(this.riepilogoIncassi[i].stripe, 10) + parseInt(this.riepilogoIncassi[i].paypal, 10) + parseInt(this.riepilogoIncassi[i].braintree, 10) + parseInt(this.riepilogoIncassi[i].allaCassa, 10);

        if (this.riepilogoIncassi[i].fonte == 'ombrelloni') {
          this.riepilogoIncassoGiornoCorrente.totaleStripeOmbrelloni = parseInt(this.riepilogoIncassi[i].stripe, 10);
          this.riepilogoIncassoGiornoCorrente.totalePayPalOmbrelloni = parseInt(this.riepilogoIncassi[i].paypal, 10);
          this.riepilogoIncassoGiornoCorrente.totaleBraintreeOmbrelloni = parseInt(this.riepilogoIncassi[i].braintree, 10);
          this.riepilogoIncassoGiornoCorrente.totaleContantiOmbrelloni = parseInt(this.riepilogoIncassi[i].allaCassa, 10);
          this.riepilogoIncassoGiornoCorrente.totaleOmbrelloni += this.riepilogoIncassoGiornoCorrente.totaleContantiOmbrelloni + this.riepilogoIncassoGiornoCorrente.totaleBraintreeOmbrelloni
            + this.riepilogoIncassoGiornoCorrente.totalePayPalOmbrelloni + this.riepilogoIncassoGiornoCorrente.totaleStripeOmbrelloni;
        } else if (this.riepilogoIncassi[i].fonte == 'bar') {
          this.riepilogoIncassoGiornoCorrente.totaleStripeBar = parseInt(this.riepilogoIncassi[i].stripe, 10);
          this.riepilogoIncassoGiornoCorrente.totalePayPalBar = parseInt(this.riepilogoIncassi[i].paypal, 10);
          this.riepilogoIncassoGiornoCorrente.totaleBraintreeBar = parseInt(this.riepilogoIncassi[i].braintree, 10);
          this.riepilogoIncassoGiornoCorrente.totaleContantiBar = parseInt(this.riepilogoIncassi[i].allaCassa, 10);
          this.riepilogoIncassoGiornoCorrente.totaleBar += this.riepilogoIncassoGiornoCorrente.totaleContantiBar + this.riepilogoIncassoGiornoCorrente.totaleBraintreeBar
            + this.riepilogoIncassoGiornoCorrente.totalePayPalBar + this.riepilogoIncassoGiornoCorrente.totaleStripeBar;
        }
      }
    }
    /*     console.log(this.riepilogoIncassi); */
  }

  resettaIncassi() {
    this.riepilogoIncassoMeseCorrente.totale = 0;
    this.riepilogoIncassoAnnoCorrente.totale = 0;
    this.riepilogoIncassoGiornoCorrente.totale = 0;
    this.riepilogoIncassoGiornoCorrente.totaleBar = 0;
    this.riepilogoIncassoGiornoCorrente.totaleOmbrelloni = 0;

    this.riepilogoIncassoMeseCorrente.totaleStripeOmbrelloni = 0;
    this.riepilogoIncassoAnnoCorrente.totaleStripeOmbrelloni = 0;
    this.riepilogoIncassoGiornoCorrente.totaleStripeOmbrelloni = 0;

    this.riepilogoIncassoMeseCorrente.totalePayPalOmbrelloni = 0;
    this.riepilogoIncassoAnnoCorrente.totalePayPalOmbrelloni = 0;
    this.riepilogoIncassoGiornoCorrente.totalePayPalOmbrelloni = 0;

    this.riepilogoIncassoMeseCorrente.totaleContantiOmbrelloni = 0;
    this.riepilogoIncassoAnnoCorrente.totaleContantiOmbrelloni = 0;
    this.riepilogoIncassoGiornoCorrente.totaleContantiOmbrelloni = 0;

    this.riepilogoIncassoMeseCorrente.totaleBraintreeOmbrelloni = 0;
    this.riepilogoIncassoAnnoCorrente.totaleBraintreeOmbrelloni = 0;
    this.riepilogoIncassoGiornoCorrente.totaleBraintreeOmbrelloni = 0;

    this.riepilogoIncassoMeseCorrente.totaleStripeBar = 0;
    this.riepilogoIncassoAnnoCorrente.totaleStripeBar = 0;
    this.riepilogoIncassoGiornoCorrente.totaleStripeBar = 0;

    this.riepilogoIncassoMeseCorrente.totalePayPalBar = 0;
    this.riepilogoIncassoAnnoCorrente.totalePayPalBar = 0;
    this.riepilogoIncassoGiornoCorrente.totalePayPalBar = 0;

    this.riepilogoIncassoMeseCorrente.totaleContantiBar = 0;
    this.riepilogoIncassoAnnoCorrente.totaleContantiBar = 0;
    this.riepilogoIncassoGiornoCorrente.totaleContantiBar = 0;

    this.riepilogoIncassoMeseCorrente.totaleBraintreeBar = 0;
    this.riepilogoIncassoAnnoCorrente.totaleBraintreeBar = 0;
    this.riepilogoIncassoGiornoCorrente.totaleBraintreeBar = 0;


  }

  getOrdiniCustomGiornalieri(dataRicevuta: string, page = 1, limit = 10, searchTerm: string, annullato: number = 0, idFasciaOraria: number | null = null): Observable<any> {

    setTimeout(() => {
      // this.spinner.show();

    }, 0);


    if (!dataRicevuta) {
      dataRicevuta = this.creaData();
    }

    // Formattatzione data
    const dataModificata = this.formatData(dataRicevuta);

    // Recupero token
    this.tokenValue = this.storage.get('token');

    // Configurazione headers
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.tokenValue}`
    });

    // Mostra spinner solo al primo caricamento
    /*   if (this.isFirstRiepilogoFetch) {
        this.spinner.show();
      } */
    if (searchTerm) {
      page = 1; // Reset della pagina se viene effettuata una ricerca
      this.paginationData.page = 1; // Reset della pagina nella struttura di paginazione
    }
    // Costruzione URL: idFasciaOraria viene incluso solo se valorizzato (null = "Tutte")
    let url = `${this.serviziRest.getOrdiniCustomGiornalieri}?data=${dataModificata}&page=${page}&limit=${limit}&filter=${searchTerm}&annullato=${annullato}`;
    if (idFasciaOraria != null) {
      url += `&idFasciaOraria=${idFasciaOraria}`;
    }
    // Restituisci l'Observable
    return this.http.get<any>(url, { headers })
      .pipe(
        tap((response: any) => {
          // Salva i dati localmente se necessario
          this.datiStoricoOrdini = [];
          this.datiStoricoOrdini = response;
          this.paginationData.totalPages = Math.ceil(response.total / this.paginationData.limit);

        }),
        finalize(() => {
          // this.spinner.hide();
          if (this.isFirstRiepilogoFetch) {
            //    this.spinner.hide();
            this.isFirstRiepilogoFetch = false;
          }
        }),
        catchError(error => {
          console.error('Errore nel caricamento ordini:', error);
          return throwError(() => error);
        })
      );
  }

  calcolaTotali(): void {
    // Mostra lo spinner durante il caricamento
    this.isLoadingTotali = true;
    this.tokenValue = this.storage.get('token');

    // Configurazione headers
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.tokenValue}`
    });

    // Fai la chiamata per ottenere TUTTI gli ordini del giorno (limite alto per avere tutti i dati)
    this.http.get<any>(`${this.serviziRest.getOrdiniCustomGiornalieri}?data=${this.dataScelta}&page=${1}&limit=${10000}`, { headers }).subscribe({
      next: (response) => {
        const datiOrdini = response;

        // Reset totali
        this.totaleOmbrPrenotati = 0;
        this.totaleOmbrelloniGiornalieri = 0;
        this.totaleIncassoGiornaliero = 0;

        // Verifica che ci siano dati
        if (!datiOrdini || !datiOrdini.listaOrdini || !Array.isArray(datiOrdini.listaOrdini)) {
          console.log('Nessun dato ordini trovato o formato non valido');
          this.isLoadingTotali = false;
          return;
        }

        // Itera attraverso la lista ordini
        datiOrdini.listaOrdini.forEach((ordine: any) => {
          // Salta gli ordini annullati se non devono essere conteggiati
          if (ordine.annullato) {
            return;
          }

          // Controlla il tipo di pagamento per determinare se è un ordine online o manuale
          const isOrdineOnline = ordine.idPagamentoStripe || ordine.idPagamentoBraintree || ordine.idPagamentoPaypal;

          if (isOrdineOnline) {
            // Ordine online (pagato con carta/PayPal)
            this.totaleOmbrPrenotati++;
          } else {
            // Ordine manuale (contanti o fonte = 3)
            this.totaleOmbrelloniGiornalieri++;
          }

          // Calcola l'incasso giornaliero (solo ordini non annullati)
          if (ordine.pagato && ordine.costo) {
            this.totaleIncassoGiornaliero += parseFloat(ordine.costo);
          }
        });

        // Log per debug
        /* console.log('Totali calcolati:', {
          totaleOmbrPrenotati: this.totaleOmbrPrenotati,
          totaleOmbrelloniGiornalieri: this.totaleOmbrelloniGiornalieri,
          totaleIncassoGiornaliero: this.totaleIncassoGiornaliero,
          totaleOmbrelloni: this.totaleOmbrPrenotati + this.totaleOmbrelloniGiornalieri
        }); */

        // Nascondi lo spinner
        this.isLoadingTotali = false;
      },
      error: (error) => {
        console.error('Errore nel calcolo dei totali:', error);
        this.isLoadingTotali = false;

        // Reset totali in caso di errore
        this.totaleOmbrPrenotati = 0;
        this.totaleOmbrelloniGiornalieri = 0;
        this.totaleIncassoGiornaliero = 0;
      }
    });
  }
  private formatData(dataRicevuta: string): string {
    const dataParts = dataRicevuta.split("-");
    const anno = dataParts[0];
    const mese = dataParts[1].padStart(2, '0');
    const giorno = dataParts[2].padStart(2, '0');

    return `${anno}-${mese}-${giorno}`;
  }

  aggiornaDatiRiepilogoCompleto(datePicker: any) {  // serve ad aggiornare lo storico ordini selezionando una data dal calendario
    this.paginationData.page = 1;
    const isDataValida = datePicker?.year && datePicker.year !== '--';

    let giorno: string, mese: string, anno: string;

    if (isDataValida) {
      giorno = String(datePicker.day).padStart(2, '0');
      mese = String(datePicker.month).padStart(2, '0');
      anno = String(datePicker.year);
    } else {
      const oggi = new Date();
      giorno = String(oggi.getDate()).padStart(2, '0');
      mese = String(oggi.getMonth() + 1).padStart(2, '0');
      anno = String(oggi.getFullYear());

      // Se la data è invalida, aggiorna il datePicker con la data odierna
      this.datePicker.dataSelezionata = {
        day: giorno,
        month: mese,
        year: anno
      };
    }

    this.dataScelta = `${anno}-${mese}-${giorno}`;
    this.dataSceltaFormatoIta = `${giorno}-${mese}-${anno}`;
    this.ultimaDataLettaRiepilogoORdini = this.dataScelta;

    this.getOrdiniCustomGiornalieri(this.dataScelta, this.paginationData.page, this.paginationData.limit, '').subscribe({
      next: (response) => {
        console.log('Ordini caricati con successo', response);
        // Qui puoi aggiungere altra logica se necessario
      },
      error: (error) => {
        console.error('Errore nel caricamento ordini:', error);
        // Gestisci l'errore (mostra un messaggio all'utente, etc.)
      },
      complete: () => {
        console.log('Caricamento completato');
      }
    });

    //  this.calcolaTotali();
  }
}
